import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const NavDocumentBold = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M19.355,22.586H4.645c-0.829,0-1.5-0.671-1.5-1.5V2.914c0-0.829,0.671-1.5,1.5-1.5h14.711\n\t        c0.828,0,1.5,0.671,1.5,1.5v18.172C20.855,21.915,20.184,22.586,19.355,22.586z M6.145,19.586h11.711V4.414H6.145V19.586z" }),
    React.createElement("rect", { x: "8.105", y: "6.606", width: "7.788", height: "3" }),
    React.createElement("rect", { x: "8.106", y: "10.068", width: "3.893", height: "3" }),
    React.createElement("rect", { x: "8.105", y: "13.394", width: "3.461", height: "3" })), 'NavDocumentBold');
export default NavDocumentBold;
